import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CompanyService } from 'src/app/services/company/company.service';
import { FormControl } from '@angular/forms';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {

  public Editor = ClassicEditor;

  @ViewChild(MatSelect) gets: MatSelect
  @ViewChild('Statu') matSelect: MatSelect;
  @ViewChild('template') template: TemplateRef<any>;
  loadPage = true
  rowsPage: number
  isLoadingResults = true;
  isRateLimitReached = false;
  Status: any
  selected;
  selectedValue: string;
  selectedLang: string
  canvasRotation
  canvasRotation2

  ComName: string = '';
  ComActivity: string = '';
  ComDetails: string = '';
  ComIsHome: any = false;
  showSave: boolean = false
  showcancel: boolean = false
  name: string;
  showUpdate: boolean = false
  showDataPanle: boolean = false
  languages: any
  ComId: string = ''
  imagesss
  imageChangedEvent: any = '';
  imageChangedEvent2: any = '';
  croppedImage: any = '';
  croppedImage2: any = '';
  imgUrl: string = ''
  imgUrl2: string = ''
  ckeConfig: any;
  id_delete: string
  id_lang: string
  showImage: boolean = true
  showImage2: boolean = true

  dis
  message
  disableSelect
  tableCom
  selectedRows
  showTableCom: boolean = false

  ComNameLink: string = ''
  ComLink: string = ''
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.showImage = false
  }

  fileChangeEvent2(event: any): void {
    this.imageChangedEvent2 = event;
    this.showImage2 = false
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

  }

  imageCropped2(event: ImageCroppedEvent) {
    this.croppedImage2 = event.base64;

  }

  cut() {
    this.showImage = true
  }
  cut2() {

    this.showImage2 = true
  }

  imageLoaded() {
  }

  imageLoaded2() {
  }

  cropperReady() {
  }

  cropperReady2() {
  }


  loadImageFailed() {

  }

  loadImageFailed2() {

  }
  getDataCom(): void {

    this.getRows('1')

    this.loadPage = true


  }

  showData(id, langId): void {
    this.loadPage = false
    this.clearData()
    this.ComIsHome = false
    this.disableSelect = null
    this.Com.getCompanyWhereId(id == null ? id = 0 : id, langId
    ).subscribe(data => {
      if (data.length != 0) {
        this.ComId = data[0]["FcomId"]
        this.ComName = data[0]["ComName"]
        this.ComActivity = data[0]["ComActivity"]
        this.selected = data[0]["ComState"]
        this.selectedLang = langId
        this.imgUrl = this.Com.imageUrl() + data[0]["ComLogo1"]
        this.imgUrl2 = this.Com.imageUrl() + data[0]["ComLogo2"]

   
          this.getBase64ImageFromURL(this.imgUrl).subscribe(base64data => {    
            this.croppedImage = 'data:image/jpg;base64,' + base64data;
            this.getBase64ImageFromURL(this.imgUrl2).subscribe(base64data => {    
              this.croppedImage2 = 'data:image/jpg;base64,' + base64data;
              this.loadPage = true
            });

            
          });

        


      }
      else {
        this.selectedLang = langId
      }
    });


    this.btnUpdate()

    this.disableSelect = new FormControl(false)

  }
  getBase64Image(img: HTMLImageElement) {
    // We create a HTML canvas object that will create a 2d image
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    // This will draw image    
    ctx.drawImage(img, 0, 0);
    // Convert the drawn image to Data URL
    var dataURL = canvas.toDataURL("image/png");
 return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
 }

 getBase64ImageFromURL(url: string) {
  return Observable.create((observer: Observer<string>) => {
    // create an image object
    let img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    if (!img.complete) {
        // This will call another method that will create image from url
        img.onload = () => {
        observer.next(this.getBase64Image(img));
        observer.complete();
      };
      img.onerror = (err) => {
         observer.error(err);
      };
    } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
    }
  });
}
  toggle(): void {

    this.showSave = !this.showcancel
  }

  btnclose() {
    this.showSave = false
    this.showcancel = false

    this.showDataPanle = false
    this.showUpdate = false
    this.clearData();
    this.showTableCom = false
  }

  btnUpdate() {
    this.showDataPanle = true
    this.showSave = false
    this.showcancel = true
    this.showUpdate = true;
    this.showTableCom = true
  }

  modalRef: BsModalRef;
  constructor(private Com: CompanyService, private _snackBar: MatSnackBar, private modalService: BsModalService) { }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  Validation(): boolean {

    if (this.selectedLang == '' || this.selectedLang == null) {
      this._snackBar.open('الرجاء اختيار لغة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }
    else if (this.ComName == '' || this.ComName == null) {

      this._snackBar.open('الرجاء ادخال اسم الشركة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }
    else if (this.croppedImage == '' || this.croppedImage == null) {

      this._snackBar.open('الرجاء اختيار صورة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }
    else if (this.selected == null) {

      this._snackBar.open('الرجاء اختيار الحالة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left'
      });
      return false;
    }

    return true;
  }


  clearData(): void {
    this.ComName = ''
    this.ComActivity = ''
    this.ComDetails = ''
    this.ComIsHome = false
    this.selected = ''
    this.croppedImage = ''
    this.imageChangedEvent = '';
    this.croppedImage2 = ''
    this.imageChangedEvent2 = '';
    this.croppedImage = 'data:image/jpeg;base64,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';
    this.croppedImage2 = 'data:image/jpeg;base64,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';

    this.imgUrl = ''
    this.ComNameLink = ''
    this.ComLink = ''
    this.ComId = null
    this.Com.getCompanylang(null).subscribe(data => {
      this.languages = data
    })
  }


  update(): void {
    this.showUpdate = false;
    this.loadPage = false


    if (this.Validation()) {

      this.Com.CompanyPost
        (
          'u', '1', this.ComName,
          this.ComActivity, this.croppedImage, this.croppedImage2,
          '1', this.selected, this.selectedLang
        ).subscribe(data => {
          this.getDataCom()
          this.clearData()
          this.btnclose()
          this._snackBar.open(data[0]["column1"], 'حسنا', {
            duration: 5000,
            horizontalPosition: 'left'
          });
          this.loadPage = true
        });

    }
    else {
      this.showUpdate = true;
      this.loadPage = true
    }
    this.ComId = ''
  }

  pageNumbers

  getRows(num) {

    if (this.rowsPage == null)
      this.rowsPage = 10
    this.Com.viewCompanyPaging(num, this.rowsPage).subscribe(data => {
      this.tableCom = data['data1']
      this.pageNumbers = data['data2']

    })
  }


  getPage(event: any) {
    this.rowsPage = event.target.value;
    this.Com.viewCompanyPaging(1, this.rowsPage).subscribe(data => {
      this.tableCom = data['data1']
      this.pageNumbers = data['data2']
    })
  }



  ngOnInit(): void {
    this.loadPage = false
    this.clearData()
    try {

      this.Com.getCompanyStatus().subscribe(data => {

        this.Status = data;

      });


      this.Com.getCompanylang(this.ComId).subscribe(data => {
        this.languages = data

      });
    }
    catch { console.log("خطأ غير متوقع") }
    try {
      this.getDataCom();
    }

    catch {
      console.log("خطأ غير متوقع")
    }
  }
}
